import React, { useState } from 'react'
import { FaBuffer, FaFileContract } from 'react-icons/fa';
import { FiList, FiSave } from "react-icons/fi";
import { RiFolderTransferFill, RiSearchEyeLine, RiFileUserLine } from "react-icons/ri"
import { AiFillFolderAdd, AiOutlineCalculator, AiOutlineSecurityScan, AiOutlineSearch, AiFillHome, AiOutlineFileSearch, AiOutlineCheckCircle } from "react-icons/ai"
import { GrFormNextLink } from "react-icons/gr"
import { FaAngleDoubleRight, FaAngleDoubleLeft } from "react-icons/fa"
import { VscTriangleRight } from "react-icons/vsc"
import { BsCheckCircleFill, BsFillArrowRightSquareFill, BsSave2 } from "react-icons/bs"
import Button from '@material-ui/core/Button';
import { GiMoneyStack } from "react-icons/gi";
import { makeStyles } from '@material-ui/core';
import { MdCancel } from "react-icons/md";

export const useBlsButton = inputData => {
    const [isHidden, setIsHidden] = useState(inputData?.isHidden ?? false)
    const [disabled, setDisabled] = useState(inputData?.disabled ?? false)

    const hide = () => setIsHidden(true);
    const show = () => setIsHidden(false);
    const disable = () => setDisabled(true);
    const enable = () => setDisabled(false);

    return {
        isHidden, disabled,
        disable, enable,
        hide, show,
    }
}

const BlsButton = ({ children, type, disabled = false, onClick, buttonStyle, size = "small", variant = "contained", hoverStyle = {}, iconPosition = "left", isHidden, iconStyle, buttonState }) => {
    let buttonTypes = [
        {
            type: "new",
            text: "Yeni",
            icon: <AiFillFolderAdd style={{ ...iconStyle }} />,
            color: "#00ACC1",
        },
        {
            type: "save",
            text: "Kaydet",
            icon: <FiSave style={{ ...iconStyle }} />,
            color: "#C39BD3",
        },
        {
            type: "update",
            text: "Güncelle",
            icon: <AiOutlineSecurityScan style={{ ...iconStyle }} />,
            color: "#4CAF50",
        },
        {
            type: "calculate",
            text: "Hesapla",
            icon: <AiOutlineCalculator style={{ ...iconStyle }} />,
            color: "#21618C",
        },
        {
            type: "scan",
            text: "Tara",
            icon: <AiOutlineSecurityScan style={{ ...iconStyle }} />,
            color: "#633974",
        },
        {
            type: "add",
            text: "Ekle",
            icon: <AiFillFolderAdd style={{ ...iconStyle }} />,
            color: "#52BE80",
        },
        {
            type: "next",
            text: "Sonraki",
            icon: <GrFormNextLink style={{ ...iconStyle }} />,
            color: "#F7DC6F",
        },
        {
            type: "addList",
            text: "Ekle",
            icon: <FaAngleDoubleRight style={{ ...iconStyle }} />,
            color: "#229954",
        },
        {
            type: "delList",
            text: "Sil",
            icon: <FaAngleDoubleLeft style={{ ...iconStyle }} />,
            color: "#D35400",
        },
        {
            type: "match",
            text: "Eşleştir",
            icon: <VscTriangleRight style={{ ...iconStyle }} />,
            color: "#3498DB",
        },
        {
            type: "search",
            text: "Sorgula",
            icon: <AiOutlineSearch style={{ ...iconStyle }} />,
            color: "#FF9800",
        },
        {
            type: "collection",
            text: "Tahsilat",
            icon: <GiMoneyStack style={{ ...iconStyle }} />,
            color: "#1E8449",
        },
        {
            type: "home",
            text: "Anasayfa",
            icon: <AiFillHome style={{ ...iconStyle }} />,
            color: "#FF5733",
        },
        {
            type: "menu",
            text: "Menü",
            icon: <BsFillArrowRightSquareFill style={{ ...iconStyle }} />,
            color: "#2471A3",
        },
        {
            type: "report",
            text: "Rapor",
            icon: <AiOutlineFileSearch style={{ ...iconStyle }} />,
            color: "#F05348",
        },
        {
            type: "approval",
            text: "Onayla",
            icon: <AiOutlineCheckCircle style={{ ...iconStyle }} />,
            color: "#14e3ba",
        },
        {
            type: "cancel",
            text: "İptal",
            icon: <MdCancel style={{ ...iconStyle }} />,
            color: "#C30203",
        },
        {
            type: "transfer",
            text: "Aktar",
            icon: <RiFolderTransferFill style={{ ...iconStyle }} />,
            color: "#496778",
        },
        {
            type: "reportGroup",
            text: "Rapor Grubu",
            icon: null,
            color: "#F05348",
        },
        {
            type: "accrument",
            text: "Tahakkuk",
            icon: <RiFolderTransferFill style={{ ...iconStyle }} />,
            color: "#F05348",
        },
        {
            type: "observation",
            text: "Gözlem",
            icon: <RiSearchEyeLine style={{ ...iconStyle }} />,
            color: "#F05348",
        },
        {
            type: "operation",
            text: "İşlem",
            icon: <BsSave2 style={{ ...iconStyle }} />,
            color: "#800080",
        },
        {
            type: "list",
            text: "Liste",
            icon: <FiList style={{ ...iconStyle }} />,
            color: "#800080",
        },
        {
            type: "select",
            text: "Seç",
            icon: <BsCheckCircleFill style={{ ...iconStyle }} />,
            color: "#117A65",
        },
        {
            type: "registry",
            text: "Sicil Tanım",
            icon: <RiFileUserLine style={{ ...iconStyle }} />,
            color: "#2980B9",
        },
        {
            type: "contract",
            text: "Sözleşme",
            icon: <FaFileContract style={{...iconStyle}}/>,
            color: "#CA6F1E",
        },

    ]

    let defaultButtonStyle = {
        type: "default",
        text: "default",
        icon: null,
        color: "#1E8449",
    };
    let buttonType = buttonTypes.find(x => x.type === type) ?? defaultButtonStyle;

    const useStyles = makeStyles({
        button: {
            backgroundColor: buttonType.color,
            '&:hover': {
                backgroundColor: Object.keys(hoverStyle).length > 0 ? hoverStyle.backgroundColor : buttonType.color,
                color: Object.keys(hoverStyle).length > 0 ? hoverStyle.color : 'white'
            },
        },
        iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18,
                position: 'absolute',
                left: iconPosition === 'left' ? 4 : 'auto',
                right: iconPosition === 'right' ? 4 : 'auto',
                top: 2
            },
        },

    })
    const classes = useStyles()

    return (
        <Button
            variant={variant}
            size={size}
            className={classes.button}
            classes={{ iconSizeSmall: classes.iconSizeSmall }}
            onClick={onClick}
            disabled={buttonState ? buttonState.disabled : disabled}
            startIcon={iconPosition === 'left' ? buttonType.icon : null}
            endIcon={iconPosition === 'right' ? buttonType.icon : null}
            style={{
                display: (buttonState ? buttonState.isHidden : isHidden) && "none",
                textTransform: 'none',
                width: '32%',
                padding: '0px',
                marginTop: '1%',
                marginLeft: "1%",
                opacity: (buttonState ? buttonState.disabled : disabled) ? 0.6 : 1,
                color: 'white',
                ...buttonStyle
            }}
        >
            {children ?? buttonType.text}
        </Button>
    );

}

export default BlsButton